export const situationMapSettlement = {
  ALL_ORDERS: { color: '#d1d5db', text: 'ALL', keys: ['Todas as Ordens'] },
  APPROVED: { color: '#d5e59e', text: 'APPROVED', keys: ['Aprovado'] },
  UNDER_REVIEW: { color: '#ffefa2', text: 'UNDER_REVIEW', keys: ['Em Aprovação', 'Aberto'] },
  DENIED: { color: '#f6bfb5', text: 'DENIED', keys: ['Reprovado'] }
}
